import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLinkedinIn,
  faSquareFacebook,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

import { useSelector } from 'react-redux';

const SHARE_HASHTAGS = [];
const TWEET_INTENT_URL = 'https://twitter.com/intent/tweet';
const FACEBOOK_SHARE_URL = 'https://www.facebook.com/sharer/sharer.php';
const LINKEDIN_SHARE_URL = 'https://linkedin.com/sharing/share-offsite';

const shareText = encodeURIComponent(`Not all streets are created equal.
Public health, mobility, and the environment are affected by local policies about the use of public space. Check out where your community ranks with #SpatialEquityNYC — a new tool from @transalt and @MITLCAU.`);

export default function ShareButton({ invert }) {
  const isMobile = useSelector((state) => state.mobile.isMobile);
  const [clicked, setClicked] = useState(isMobile ? true : false);

  const shareUrl = encodeURIComponent(window.location.href);

  useEffect(() => {
    if (isMobile) {
      setClicked(true);
    } else {
      setClicked(false);
    }
  }, [isMobile]);

  const [linkCopied, setLinkCopied] = useState(false);

  const copyURL = () => {
    navigator.clipboard.writeText(window.location.href);
  };

  const pickColor = (e) => {
    const color = 'rgb(255, 0, 0)';
    e.target.style.color = color;
  };

  return (
    <div
      className={'issues-tile-header floating-share'}
      style={{ justifyContent: isMobile ? 'flex-start' : '' }}
    >
      <div
        className={'share-button-container noselect'}
        onMouseEnter={() => {
          if (!isMobile) setClicked(true);
        }}
        onMouseLeave={() => {
          if (!isMobile) setClicked(false);
          setLinkCopied(false);
        }}
        // Allow click to activate, deactivate share dropdown on mobile
        // onClick={() => isMobile && setClicked(!clicked)}
        style={invert && { backgroundColor: 'black' }}
      >
        {clicked && (
          <div className={'share-icons'}>
            {isMobile && <a href="#">+Share</a>}
            <a
              target="_blank"
              rel="noreferrer"
              href={`${FACEBOOK_SHARE_URL}?u=${shareUrl}`}
            >
              <FontAwesomeIcon
                icon={faSquareFacebook}
                onClick={(e) => {
                  pickColor(e);
                }}
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={`${TWEET_INTENT_URL}?text=${shareText}&url=${shareUrl}${
                SHARE_HASHTAGS.length
                  ? `&hashtags=${SHARE_HASHTAGS.join(',')}`
                  : ''
              }`}
            >
              <FontAwesomeIcon
                icon={faTwitter}
                onClick={(e) => {
                  pickColor(e);
                }}
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={`${LINKEDIN_SHARE_URL}?url=${shareUrl}`}
            >
              <FontAwesomeIcon
                icon={faLinkedinIn}
                onClick={(e) => {
                  pickColor(e);
                }}
              />
            </a>
            <a href="#">
              <FontAwesomeIcon
                icon={faCopy}
                onClick={(e) => {
                  e.preventDefault();
                  copyURL();
                  pickColor(e);
                  setLinkCopied(true);
                }}
              />
            </a>
            {linkCopied && (
              <div
                className={'position-absolute url-copied'}
                style={{ color: isMobile ? 'black' : 'white' }}
              >
                Link copied!
              </div>
            )}
          </div>
        )}

        {!isMobile && (
          <div className="share-icon-container share-icons float-right">
            {((!isMobile && !clicked) || (isMobile && clicked)) && (
              <a href="#">+ Share</a>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
